import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Loading from "../common/Loading";
import BubbleBackground from "../common/BubbleBackground";
import OldHeader from "./OldHeader";

const Layout = () => {
  // const navigation = useNavigation();
  // const location = useLocation();

  // const isLoading = useMemo(() => navigation.state === "loading", [navigation.state]);
  // const fullHeaderPages = ['/']; // Future: conditionally render headers

  return (
    <>
      {/*{isLoading && <Loading />}*/}
      <BubbleBackground />
      {/*<div className={`min-h-screen flex flex-col ${isLoading ? 'opacity-50 pointer-events-none' : ''}`}>*/}
        {/* Conditional Header Logic (if needed) */}
        {/* {fullHeaderPages.includes(location.pathname) ? <OldHeader /> : <Header />} */}
        <OldHeader />
        <main className="flex-grow">
          {/* Suspense fallback for lazy-loaded routes */}
          <Suspense fallback={<Loading />}>
            <Outlet />
          </Suspense>
        </main>
        <Footer />
      {/*</div>*/}
    </>
  );
};

export default Layout;
